var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2904 4.13628L13.9274 10.4999L20.2904 16.8631C21.2368 17.8099 21.2368 19.3437 20.2904 20.2905C19.8175 20.7634 19.1975 21 18.5778 21C17.957 21 17.337 20.7637 16.8645 20.2905L10.5001 13.9265L4.13629 20.2904C3.66345 20.7633 3.04339 20.9999 2.42316 20.9999C1.8031 20.9999 1.18346 20.7637 0.710203 20.2904C-0.236252 19.344 -0.236252 17.8103 0.710203 16.8631L7.07296 10.4998L0.709841 4.13628C-0.236614 3.18982 -0.236614 1.65575 0.709841 0.709297C1.65612 -0.236432 3.18929 -0.236432 4.13593 0.709297L10.5001 7.07288L16.8637 0.709297C17.8105 -0.236432 19.3439 -0.236432 20.29 0.709297C21.2368 1.65575 21.2368 3.18982 20.2904 4.13628Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.11feea34c15d5f8f975c8add840302ed.svg";
export { ForwardRef as ReactComponent };